import { reactive } from 'vue'
import { createGlobalState } from '@vueuse/core'
import * as accountService from "../utils/accountService";
import { cacheUtil } from "@cttq/basic-tool-v3/cache";
import { ActionParamType } from "../utils/interface";
import { ActionResponseType, UserType ,MenuType} from "../utils/interface";
import type { ResponseType } from "@cttq/cttq-request";

export const userGlobalState = createGlobalState(() => {
    let state = reactive({
        testStatu: false,
        userInfo: {} as UserType,
        userMenu: [] as MenuType[],
        resourceCode: ""
    })
    function getUserInfo(): Promise<ResponseType<Array<UserType>>> {
        return accountService.getUserInfo().then((res) => {
          if (res && res.responseData && res.responseData.length > 0) {
            cacheUtil.setObject({ key: "menus", value: res.responseData[0] });
            // 存储个人信息
            state.userInfo = res.responseData[0]
            // 返回 res，因为我们需要一个 ResponseType<UserType[]>
            return res;
          } else {
            // 如果 res 或 res.responseData 不存在，或者数组长度为0，这里返回一个空数组
            // 这样可以保证返回的 Promise 总是解析为 ResponseType<UserType[]>
            return { responseData: [] } as ResponseType<Array<UserType>>;
          }
        });
    }
    // 缓存token 账户 改版判断是否第一次登录
    function initAccount(param:string) {
        return accountService.loginForSimulator(param).then((res) => {
            if(res.data) {
                let result = res.data;
                // 缓存token和account
                cacheUtil.set({key:"ssosatoken", value: result.ssosatoken})
                cacheUtil.set({key:"account", value: result.account})
                // 修改状态，避免重复调用initAccount方法
                state.testStatu = true
                // 存储个人信息
                state.userInfo = result.userDetail
            }
        })
    }
    // 获取用户菜单并存储
    function getUserMenuList(param:string):Promise<MenuType[]> {
        return accountService.getUserMenu(param).then((res) => {
            cacheUtil.setObject({key:"menus",value: res.responseData})
            if(res && res.responseData) {
                state.userMenu = res.responseData
            }
            return res.responseData || []
        });
    }
    // 获取用户权限
    function getUserAction(param:ActionParamType):Promise<ActionResponseType> {
        return accountService.getUserAction(param.account, param.code).then((res) => {
            return res
        });
    }
    // 获取用户对应资源码
    function changeResourceCode(code:string) {
        state.resourceCode = code;
    }
    // 登出
    function logout() {
        return accountService.logoutAction()
    }
    return {
        state,
        getUserInfo,
        initAccount,
        getUserMenuList,
        getUserAction,
        changeResourceCode,
        logout
    }
})
